import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "mb-15 mb-sm-20 text-black" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = ["required", "placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_17 = ["required", "placeholder"]
const _hoisted_18 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_25 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "form-check form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = { class: "form-check form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "form-check form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 1,
  class: "col-12"
}
const _hoisted_41 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_42 = { class: "d-flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_43 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_44 = { class: "row justify-content-center" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('page.invitation_form')), 1 /* TEXT */),
        _createElementVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" INSTRUCTIONS "),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('form.invite_user_instructions')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" ANAGRAPH "),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t('form.section.user_information')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" FIRST NAME "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('form.first_name.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstname) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.firstname }]]),
                  required: !_ctx.is_patient,
                  placeholder: _ctx.$t('form.first_name.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_12), [
                  [_vModelText, _ctx.user.firstname]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.firstname ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.firstname, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" LAST NAME "),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('form.last_name.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.lastname) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.lastname }]]),
                  required: !_ctx.is_patient,
                  placeholder: _ctx.$t('form.last_name.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_17), [
                  [_vModelText, _ctx.user.lastname]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.lastname ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lastname, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_19,
            _createCommentVNode(" ROLE_IN_DEPARTMENT \n          <div class=\"col-md-6\">\n            <div class=\"form-group mb-15 mb-sm-20 mb-md-25\">\n              <label class=\"d-block text-black fw-semibold mb-10\">\n                {{ $t('form.role_in_department.label') }}\n              </label>\n              <input v-model=\"user.role_in_department\" class=\"form-control shadow-none text-black\"\n                :class=\"[{ 'is-invalid': submitted && errors?.role_id }]\" />\n               ERRORS \n              <div class=\"form-messages mt-2 px-1\" v-if=\"errors?.role_in_department ?? false\">\n                <p v-for=\"error in errors.role_in_department\" :key=\"error\" class=\"small text-danger lh-1 m-0 mt-1\">{{\n                  error }}</p>\n              </div>\n            </div>\n          </div> "),
            _createCommentVNode(" CONTACTS "),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.$t('form.section.contacts')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" CREATE "),
            _createCommentVNode(" EMAIL "),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event)),
                  type: "email",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.email }]]),
                  required: "",
                  disabled: "",
                  pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+"
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.user.email]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.email ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" PHONE "),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.phone_number) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.phone_number }]]),
                  placeholder: _ctx.$t('form.phone.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_29), [
                  [_vModelText, _ctx.user.phone_number]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.phone_number ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.phone_number, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          (_ctx.env === 'sifi_fk' || _ctx.env === 'fungalk')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createCommentVNode(" CHECKBOXES "),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input shadow-none",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.terms_of_use_accepted) = $event)),
                      id: "terms_of_use",
                      required: true
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.terms_of_use_accepted]
                    ]),
                    _createElementVNode("label", {
                      class: "form-check-label fw-medium position-relative top-1",
                      for: "terms_of_use",
                      innerHTML: _ctx.$t('invitation_policies.terms_of_use', {url: _ctx.$t(`footer_links.terms_of_use.${_ctx.env}`)})
                    }, null, 8 /* PROPS */, _hoisted_33)
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", {
                      class: "form-check-label fw-medium position-relative top-1",
                      innerHTML: _ctx.$t('invitation_policies.privacy_policy', {url: _ctx.$t(`footer_links.privacy_policy.${_ctx.env}`)})
                    }, null, 8 /* PROPS */, _hoisted_36)
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", {
                      class: "form-check-label fw-medium position-relative top-1",
                      innerHTML: _ctx.$t('invitation_policies.cookie_policy', {url: _ctx.$t(`footer_links.cookie_policy.${_ctx.env}`)})
                    }, null, 8 /* PROPS */, _hoisted_39)
                  ])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_SpinnerLoading)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createCommentVNode(" SAVE "),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_DiscardButton, {
                      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({
                path: '/login'
              })))
                    }),
                    _createElementVNode("button", {
                      class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                      type: "submit",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitted = true))
                    }, _toDisplayString(_ctx.$t('cta.accept_invitation')), 1 /* TEXT */)
                  ])
                ])
              ]))
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "alertModal",
      title: _ctx.$t('error.something_went_wrong'),
      message: _ctx.error_message,
      onConfirm: _ctx.redirect,
      dismissible: false
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"]),
    _createVNode(_component_AlertModal, {
      id: "successModal",
      title: _ctx.$t('feature.auth.invitation'),
      message: _ctx.$t('feature.auth.$invitation.accept_success_message'),
      onConfirm: _ctx.redirect
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"])
  ], 64 /* STABLE_FRAGMENT */))
}